/*
 * Lib Module CounterCallback
 */

/**
 * TODO: Document
 * @param cb
 * @returns {{counter: number, cb: *}}
 * @constructor
 */
Lib.CounterCallback = function (cb) {
    var self = {
        counter: 0,
        cb: cb
    };

    self.increase = function () {
        self.counter++;
    };

    self.decrease = function () {
        self.counter--;
        if (self.counter < 0) {
            self.counter = 0;
        }

        if (self.isEmpty()) {
            self.launchCallback();
        }
    };

    self.isEmpty = function () {
        return (self.counter === 0);
    };

    self.setEmpty = function () {
        self.counter = 0;
        self.launchCallback();
    };

    self.launchCallback = function () {
        if (typeof self.cb === 'function') {
            return self.cb();
        }
    };

    return self;

};
